import { render, staticRenderFns } from "./entry-info.vue?vue&type=template&id=c0f7874c&scoped=true&"
import script from "./entry-info.vue?vue&type=script&lang=js&"
export * from "./entry-info.vue?vue&type=script&lang=js&"
import style0 from "./entry-info.vue?vue&type=style&index=0&id=c0f7874c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7874c",
  null
  
)

export default component.exports